import avatars from '../../../utils/avatars';
import { ReactComponent as Next } from '../../../../images/icons/next.svg';
import { ReactComponent as Previous } from '../../../../images/icons/back.svg';
import { useState } from 'react';

interface Props{
    onAvatarSet: (url:string) => void
}
const Avatars = ({onAvatarSet}: Props) => {
    const step = window.matchMedia('(min-width: 768px)').matches ? 5 :
                (window.matchMedia('(min-width: 640px)').matches ? 3 : 2);
    const [groupIndex, setGroupIndex] = useState(0);
    const startIndex = groupIndex * step;
    const endIndex = startIndex + step;
    const displayArray = avatars.slice(startIndex, endIndex);

    const onNext = () => {
        setGroupIndex((groupIndex + 1) % Math.ceil(avatars.length / step));
    };
    const onPrevious = () => {
       setGroupIndex((groupIndex - 1 + Math.ceil(avatars.length / step)) % Math.ceil(avatars.length / step));
    };

    return (
        <div className='flex justify-center items-center'>
            <button type="button" className='flex justify-start items-center w-[30px] h-[30px]' onClick={onPrevious}><Previous/></button>
            <ul className='flex gap-[12px] mt-[81px] mb-[81px] '>
                {displayArray.map(avatar => {
                    return (
                        <li key={avatar.s} onClick={()=>onAvatarSet(avatar.lg)}
                            className='w-[89px] h-[89px] border-[3px] cursor-pointer rounded-full border-solid border-white drop-shadow-[4px_4px_19px_rgba(0,0,0,0.25)] hover:border-[#DC3545] hover:drop-shadow-[8px_8px_30px_rgba(0,0,0,0.25)] transition-all ease-in-out duration-200'>
                            <img src={avatar.s} alt="avatar"/>
                        </li>
                    )
                })}
            </ul>
            <button type="button" className='flex justify-end items-center w-[30px] h-[30px]' onClick={onNext}><Next/></button>
        </div>
    )
};

export default Avatars;
